import { render, staticRenderFns } from "./inviteConf.vue?vue&type=template&id=3be8bedc&scoped=true&"
import script from "./inviteConf.vue?vue&type=script&lang=js&"
export * from "./inviteConf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be8bedc",
  null
  
)

export default component.exports